module.exports = __webpack_public_path__ + "static/media/symbols.e369b265.svg";